export interface Exportable {
  readonly CSV_HEADERS: string[];

  asCsv(): string[];
}

export function getDataForExport<E extends Exportable>(
  exportables: E[],
  extension: ((e: E, row: string[]) => void) | undefined = undefined
): string[][] {
  const data: string[][] = [];

  exportables.forEach((e) => {
    const row = e.asCsv()
    if (extension) {
      extension(e, row)
    }

    data.push(row);
  });

  return data;
}
